// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"6884b6db","787":"965dc8f9"}[chunkId] + ".chunk.js";
};